const searchActivities = (state = {}, action) => {
    let localState = state;
    switch (action.type) {
        case 'SEARCH_ACTIVITIES_SUCCESS':
            localState = action.data;
            return localState;
        default:
            return localState;
    }
};

export default searchActivities;
